import { render, staticRenderFns } from "./recRole.vue?vue&type=template&id=11c16c8a&"
import script from "./recRole.vue?vue&type=script&lang=js&"
export * from "./recRole.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports